/**
 * Утилиты для работы со статусами талантов (клиентская часть)
 * Использует общий файл shared/talentStatuses.json для синхронизации с сервером
 */

import talentStatusesConfig from '../../../shared/talentStatuses.json';

/**
 * Получает все неактивные статусы из конфигурации
 * @returns {Array<string>} - Массив всех неактивных статусов
 */
export const getAllInactiveStatuses = () => {
  return talentStatusesConfig.INACTIVE_STATUSES || [];
};

/**
 * Определяет, является ли статус неактивным
 * @param {string|null} statusName - Название статуса
 * @returns {boolean} - true если статус неактивный
 */
export const isInactiveStatus = (statusName) => {
  if (!statusName) return false;
  
  const trimmedStatus = statusName.trim();
  const inactiveStatuses = getAllInactiveStatuses();
  
  return inactiveStatuses.includes(trimmedStatus);
};

/**
 * Вычисляет значение is_active на основе статуса
 * @param {Object|null} status - Объект статуса с полем name
 * @returns {boolean} - Значение is_active (true если активен, false если неактивен)
 */
export const calculateIsActive = (status) => {
  if (!status || !status.name) {
    return true; // По умолчанию активен, если статус не указан
  }
  
  return !isInactiveStatus(status.name);
};

export default {
  getAllInactiveStatuses,
  isInactiveStatus,
  calculateIsActive
};

